import { Handle, Position, type NodeProps } from "@xyflow/react";

import type { BrainFlowNodeData } from "../brainToFlow";

export default function BrainLeafNode({ data }: NodeProps) {
  const d = data as BrainFlowNodeData;
  const selected = !!d.selected;
  return (
    <div
      className="nopan flex max-w-[148px] cursor-pointer items-center gap-1.5 rounded-full border bg-white px-2.5 py-1.5 shadow-sm transition-shadow hover:shadow-md"
      style={{
        borderColor: selected ? d.color || "#64748b" : "#e2e8f0",
        backgroundColor: selected ? d.fill || "#fff" : "#fff",
        boxShadow: selected ? `0 0 0 2px ${d.color || "#64748b"}33` : undefined,
      }}
      title={d.label}
    >
      <Handle type="target" position={Position.Left} className="!opacity-0" />
      <span
        className="h-2.5 w-2.5 shrink-0 rounded-full"
        style={{ backgroundColor: d.color || "#94a3b8" }}
      />
      <span className="truncate text-[11px] font-semibold leading-tight text-slate-800">
        {d.label}
      </span>
    </div>
  );
}
